import React, {useRef, useEffect, useState} from 'react';
import './ServicesSection.scss';
import Container from 'reactor/components/Grid/ContainerWithWidth';
import GridItem from 'reactor/components/Grid/GridItem';
import BoxItem from 'reactor/components/Box';
import Image from 'reactor/components/Image';
import Heading from './../../components/heading';
import Cart from 'assets/images/cart.png'
import Design from 'assets/images/design.png'
import Mobile from 'assets/images/mobile.png'
import Circle from 'assets/images/circle.png'
import Youtube from 'assets/images/youtube.png'
import Hosting from 'assets/images/hosting.png'

const items = [
    {
        id: 1,
        title: <span>تصميم <br/> المواقع الإلكترونية</span>,
        href: '/webdesign',
        img: Design,
        content: 'أسس عمل تجاري وليس مجرد موقع عبر الانترنت من خلال تصميم إبداعي مواكب لأحدث التقنيات.'
    },
    {
        id: 2,
        title: <span>تصميم  <br/> المتاجر الإلكترونية</span>,
        href: 'https://products.rh.net.sa/store/web/',
        out: true,
        img: Cart,
        content: 'ابدأ تجارتك على الانترنت وقم بالوصول لشريحة أوسع من الجمهور وذلك بإطلاق متجرك الإلكتروني.'
    },
    {
        id: 3,
        title: <span>تصميم <br/> تطبيقات الجوال</span>,
        href: '/apps',
        img: Mobile,
        content: 'نصمم تطبيقات جوال آيفون، وأندرويد باستخدام أحدث وأفضل التقنيات والوسائل؛ لتكون على هواتف عملائك.'
    },
    {
        id: 4,
        title: <span>تصميم <br/> الهوية التجارية</span>,
        href: '/',
        img: Circle,
        content: 'نصمم علامتك التجارية على أساس استراتيجي لتوصل رسالتك بأفضل شكل وتعكس ما يهدف إليه عملك التجاري.'
    },
    {
        id: 5,
        title: <span>الفيديوهات الحية <br/> والموشن جرافيك</span>,
        href: '/',
        img: Youtube,
        content: 'شارك رؤيتك وأفكارك المعقدة بشكل بسيط وشيق مع الفيديوهات الحية والموشن جرافيك فى قصة مميزة لا تُنسى.'
    },
    {
        id: 6,
        title: <span>استضافة <br/> المواقع  الإلكترونية</span>,
        href: '/sharedhosting',
        img: Hosting,
        content: 'نضمن لك استقرار موقعك بنسبة 99% مع استضافة قوية للمؤسسات أو الشركات أو الأفراد مع حماية ضد الهجمات.'
    }
]


export default function Services() {
    const sectionRef = useRef(null);

    // const intersection = useIntersection(sectionRef, {
    //     root: null,
    //     rootMargin: '0px',
    //     threshold: 0.3
    // });

    // const fadeIn = (element) => {
    //     gsap.to(element, 1, {
    //         opacity: 1,
    //         y: -20,
    //         ease: 'power4.out',
    //         stagger: {
    //             each: 0.3,
    //             from: 'start'
    //         }
    //     });
    // }

    // const fadeOut = (element) => {
    //     gsap.to(element, 1, {
    //         opacity: 0,
    //         y: 0,
    //         ease: 'power4.out',
    //     });
    // }

    // useEffect(() => {
    //     if (intersection) {
    //         if (intersection.intersectionRatio < 0.3) {
    //             fadeOut('.fadeIn');
    //         } else {
    //             fadeIn('.fadeIn');
    //         }
    //     }
    // }, [intersection]);

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height
        };
    }

    function useWindowDimensions() {
        const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

        useEffect(() => {
            function handleResize() {
                setWindowDimensions(getWindowDimensions());
            }

            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return windowDimensions;
    }

    const { width } = useWindowDimensions();

    return (
        <div ref={sectionRef} id="services__section">
            <Container block="true">
                <Heading className='fadeIn' title="بكل إبداع، بكل فن <br/> انطلاقتك تبدأ من هنا" />
                <BoxItem display="flex" flexWrap="wrap" className="services__items">
                    {items.map((item, index) => {
                        // if (width < 760 && index < 3) {
                        //     return (
                        //         <GridItem key={item.id} className="service__item fadeIn" sm={4} xs={12}>
                        //             <Link href={item.href}>
                        //                 <div className="service__item--top">
                        //                     <BoxItem className="service__item--image">
                        //                         <Image src={item.img} alt={item.title} />
                        //                     </BoxItem>
                        //                     <h3 className="service__item--title">{item.title}</h3>
                        //                 </div>
                        //                 <p className="service__item--content lightFont__smallSize">{item.content}</p>
                        //             </Link>
                        //         </GridItem>
                        //     );
                        // } else if (width >= 760) {
                            return (
                                <GridItem key={item.id} className="service__item fadeIn" xs={12} sm={6} md={4}>
                                    <a href={item.href} target={item.out ? "_blank": ""}>
                                        <div className="service__item--top">
                                            <BoxItem className="service__item--image">
                                                <Image src={item.img} alt={item.title} />
                                            </BoxItem>
                                            <h3 className="service__item--title">{item.title}</h3>
                                        </div>
                                        <p className="service__item--content lightFont__smallSize">{item.content}</p>
                                    </a>
                                </GridItem>
                            );
                        // }
                        // return null;
                    })}
                </BoxItem>
                {/* <MoreLink linkname="المزيد من <br/> الخدمات" /> */}
            </Container>
        </div>
    );
}